const calculatePercentage = ({ num, total }) => (num / total) * 100

export default calculatePercentage
